import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { apiCall } from '@savgroup-front-common/core/services';
import { RequiredPayloadFieldIsNotProvided } from '@savgroup-front-common/exceptions/client/errors/RequiredPayloadFieldIsNotProvided';
import {
  AdditionalInformationDto,
  BackResponse,
} from '@savgroup-front-common/types';

const URL = `${APIConfiguration.claim}orders/${COMMON_QUERY_PARAMS.ORDER_ID}/claimGroups`;

interface CreateClaimGroupFromOrder {
  orderId: string;
  orderLineReferences: string[];
  externalCaseId?: string;
  claimOrigin?: string;
  currentSite?: string;
}

interface CreateClaimGroupFromOrderResponse {
  claimGroupId: string;
  additionalInformations: AdditionalInformationDto[];
}

/**
 * @deprecated this on is throwing error instead of returning failure response
 * @param orderId
 * @param orderLineReferences
 * @param externalCaseId
 * @param claimOrigin
 * @param currentSite
 */
async function createClaimGroupFromOrder({
  orderId,
  orderLineReferences,
  externalCaseId,
  claimOrigin,
  currentSite,
}: CreateClaimGroupFromOrder): Promise<
  BackResponse<CreateClaimGroupFromOrderResponse>
> {
  if (!orderId && !orderLineReferences) {
    throw new RequiredPayloadFieldIsNotProvided(
      JSON.stringify({ orderId, orderLineReferences }),
      `createClaimGroupFromOrder`,
    );
  }

  const body = new FormData();

  body.append('orderLineReferences', orderLineReferences.join(','));
  body.append('externalCaseId', externalCaseId || '');
  body.append('claimOrigin', claimOrigin || '');
  body.append('currentSite', currentSite || '');

  const response = await apiCall<
    BackResponse<CreateClaimGroupFromOrderResponse>
  >(URL.replace(COMMON_QUERY_PARAMS.ORDER_ID, orderId), {
    method: SUPPORTED_METHODS.POST,
    body,
  });

  if (response.failure) {
    throw new Error(`Got an exception trying to createClaimGroupFromOrder`);
  }

  return response;
}

export default createClaimGroupFromOrder;
